import isMobilePhone from 'validator/lib/isMobilePhone'

export default Validator => {
	Validator.register(
		'mobile',
		function(value = '') {
			return isMobilePhone(value.replace(/\s/g, ''))
		},
		'Mobilnummeret er ikke gyldig',
	)
}
